// removed by extract-text-webpack-plugin
module.exports = {"InnerWrapper":"AppleLogin-module__InnerWrapper__2_Xcv","AppleSvg":"AppleLogin-module__AppleSvg__3Pu8Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/AppleLogin/AppleLogin.module.css
// module id = 1716
// module chunks = 31